<!-- Текстовая action-ссылка для переходов к настройкам и коротких действий рядом с полями. -->
<template>
  <a
    v-if="resolvedHref"
    class="base-action-link"
    :href="resolvedHref"
    :target="linkTarget"
    :rel="relValue"
    @click="handleLinkClick"
  >
    <slot />
  </a>

  <button
    v-else
    class="base-action-link"
    type="button"
    :disabled="disabled"
    @click="handleButtonClick"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "BaseActionLink",

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: "",
    },
    target: {
      type: String,
      default: "",
    },
    to: {
      type: [Object, String],
      default: null,
    },
  },

  emits: ["click"],

  computed: {
    resolvedHref() {
      if (this.href) return this.href;
      if (!this.to) return "";

      return this.$router.resolve(this.to).href;
    },

    linkTarget() {
      return this.target || "_blank";
    },

    relValue() {
      return this.linkTarget === "_blank" ? "noopener noreferrer" : null;
    },
  },

  methods: {
    handleLinkClick(event) {
      this.$emit("click", event);

      if (!this.shouldUseRouterPush(event)) return;

      event.preventDefault();
      this.$router.push(this.to);
    },

    handleButtonClick(event) {
      if (this.disabled) return;

      this.$emit("click", event);
    },

    shouldUseRouterPush(event) {
      return (
        this.to &&
        this.linkTarget === "_self" &&
        !event.defaultPrevented &&
        event.button === 0 &&
        !event.metaKey &&
        !event.ctrlKey &&
        !event.shiftKey &&
        !event.altKey
      );
    },
  },
};
</script>

<style scoped>
.base-action-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  padding: 0;
  border: none;
  color: var(--color-blue, #3182ce);
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s ease;
}

.base-action-link:hover,
.base-action-link:focus-visible {
  color: var(--color-blue-hover, #2b6cb0);
  text-decoration: underline;
}

.base-action-link:focus-visible {
  outline: 2px solid var(--color-blue, #3182ce);
  outline-offset: 2px;
}

.base-action-link:disabled {
  color: #9ca3af;
  cursor: not-allowed;
  text-decoration: none;
}
</style>
